module.exports = {"611023001":"城关街道","611023101":"富水镇","611023102":"湘河镇","611023104":"赵川镇","611023107":"过风楼镇","611023108":"试马镇","611023109":"清油河镇","611023110":"十里坪镇","611023111":"金丝峡镇","611023112":"青山镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/611023.json
// module id = 3025
// module chunks = 0